/* eslint-disable import/prefer-default-export */

/**
 * Menampilkan popup peringatan menggunakan SweetAlert2 jika pengguna belum melengkapi profil bisnis.
 *
 * @function
 * @param {Function} swal - Instance dari SweetAlert2 (biasanya di-inject dari luar).
 * @returns {Promise<SweetAlertResult>} Promise yang menyelesaikan hasil dari interaksi popup,
 * seperti konfirmasi atau batal.
 *
 * @example
 * import Swal from 'sweetalert2'
 * popupOptionalLengkapiProfilBusiness(Swal).then((result) => {
 *   if (result.isConfirmed) {
 *     // Navigasi ke halaman lengkapi profil bisnis
 *   }
 * });
 */
export function popupOptionalLengkapiProfilBusiness(swal) {
  return swal({
    text: 'Kamu belum melengkapi Profile Bisnis. Yuk Lengkapi dulu Profile Bisnismu!',
    icon: 'warning',
    iconHtml: '<img width="100px" height="100px" src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png">',
    customClass: {
      popup: '!max-w-[500px] !w-full',
      icon: 'border-0 !w-[100px] !h-[100px] mb-2',
      actions: 'flex justify-center items-center gap-2 mt-2',
      confirmButton: 'btn btn-primary px-4 flex-1',
      cancelButton: 'btn btn-outline-primary px-4 flex-1',
    },
    confirmButtonText: 'Lengkapi Data',
    showCancelButton: true,
    cancelButtonText: 'Nanti Saja',
    buttonsStyling: false,
    reverseButtons: true,
    allowOutsideClick: false,
    allowEscapeKey: false,
  })
}
